import { Reducer } from 'redux';

import {
  INTENTS_SET_DATA,
  INTENTS_SET_LOADING,
  INTENTS_SET_ACTIVE,
  INTENTS_SET_LOADED,
} from './actions';
import { IntentsState } from './interfaces/IntentsState';

const INITIAL_STATE: IntentsState = {
  loading: false,
  active: null,
  data: [],
  loaded: false,
};

export const IntentsReducer: Reducer<IntentsState> = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case INTENTS_SET_LOADING:
      return {
        ...state,
        loading: payload.loading,
      };
    case INTENTS_SET_DATA:
      return {
        ...state,
        data: payload.intents,
        loading: false,
      };
    case INTENTS_SET_ACTIVE:
      return {
        ...state,
        active: payload.intent,
        loading: false,
      };
    case INTENTS_SET_LOADED:
      return {
        ...state,
        loaded: payload.loaded,
        loading: false,
      };
    default:
      return state;
  }
};
